import React from 'react';
import './location-drop.css';
export default function LocationDrop() {
  return (
    <div className='location-container'>
        <div className="location-details">
            <p className="main-location">
                Don McGill Toyota
            </p>
            <p className="sub-location">
                11800 Katy Freeway
            </p>
            <p className="sub-location">
                Houston TX 77079
            </p>
        </div>
        <button>Get Directions</button>
    </div>
  )
}
